import { render, staticRenderFns } from "./SsnEditor.vue?vue&type=template&id=5f7e27b8"
import script from "./SsnEditor.vue?vue&type=script&lang=ts"
export * from "./SsnEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports